export const threeStepFlow = [
  {
    title: 'howItWorks.3step.start.title',
    description: 'howItWorks.3step.start.desc',
  },
  {
    title: 'howItWorks.3step.train.title',
    description: 'howItWorks.3step.train.desc',
  },
  {
    title: 'howItWorks.3step.dance.title',
    description: 'howItWorks.3step.dance.desc',
  },
];

export const fourStepFlow = [
  {
    title: 'howItWorks.4step.buy.title',
    description: 'howItWorks.4step.buy.desc',
  },
  {
    title: 'howItWorks.4step.train.title',
    description: 'howItWorks.4step.train.desc',
  },
  {
    title: 'howItWorks.4step.feedback.title',
    description: 'howItWorks.4step.feedback.desc',
  },
  {
    title: 'howItWorks.4step.dance.title',
    description: 'howItWorks.4step.dance.desc',
  },
];